import mainBanner from '../../assets/banner_nos-renovamos.jpg'
import mainBannerM from '../../assets/banner_nos-renovamos_mobile-lg.jpg'

export const translations = {
    main_banner_section: {
        banner: mainBanner,
        bannerMobile: mainBannerM,
    }
}